import { useNavigate, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { PaymentStatusEnum, useProcessingPayment } from 'api/ProcessingPayment/sdk.ts';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../../components/Loader';
import { H2 } from 'components/ui/typography.tsx';

export const ProcessingPayment = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data } = useProcessingPayment(id, {
    refreshInterval: (data) => (data?.status === PaymentStatusEnum.PENDING ? 2000 : 0),
  });
  const [searchParams] = useSearchParams();
  const flightOfferUUID = searchParams.get('flightOfferUUID');
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (data != null && data.status !== PaymentStatusEnum.PENDING) {
      setLoading(false);
      navigate(`/flights/offer/${flightOfferUUID}`);
    }
  }, [data, flightOfferUUID, navigate]);

  return (
    <div className='flex min-h-screen flex-col items-center justify-center gap-4'>
      <H2>{t('payment.processingPayment')}</H2>
      {loading && <Loader className='size-20 text-primary' />}
    </div>
  );
};
